import { NavLink, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import { getBrandLogoSvg } from '../../branding/brandings';

const logoSrc = getBrandLogoSvg();
export const NotFoundPage = () => {

    const { t } = useTranslation();
    const navigate = useNavigate();

    const onNavigateBack = () => {
        document.body.classList.remove('template-error');
        navigate(-1);
    }

    const onNavigateHome = () => {
        document.body.classList.remove('template-error');
        navigate('/', { replace: true });
    }

    useEffect(() => {
        document.body.classList.add('template-error');
    }, []);

    return (
        <div className="component-error">

            <div className="errorPage">
                <img src={logoSrc} className="img-fluid" alt={t('navbar.logo')} />

                <div className="errorPage__text">
                    <h2 className="error__type"> {t('not-found.error-type')} </h2>
                    <h3 className="error__title"> {t('not-found.title')} </h3>
                    <p className="error__detail"> {t('not-found.detail-1')} <br /> {t('not-found.detail-2')} </p>
                    <button onClick={onNavigateBack} className="btn-medium btn-primary"> {t('not-found.go-back')} </button>
                    <NavLink to="/" onClick={onNavigateHome} className="base-link"> {t('not-found.go-home')} </NavLink>
                </div>
            </div>

        </div>
    )
}